'use strict';

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('ipld-dag-pb'),
    DAGLink = _require.DAGLink,
    DAGNode = _require.DAGNode;

var _require2 = require('buffer'),
    Buffer = _require2.Buffer;

var UnixFS = require('ipfs-unixfs');

var multihashing = require('multihashing-async');

var Dir = require('./dir');

var persist = require('./utils/persist');

var Bucket = require('hamt-sharding');

var mergeOptions = require('merge-options').bind({
  ignoreUndefined: true
});

var hashFn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    var hash, justHash, length, result, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return multihashing(Buffer.from(value, 'utf8'), 'murmur3-128');

          case 2:
            hash = _context.sent;
            // Multihashing inserts preamble of 2 bytes. Remove it.
            // Also, murmur3 outputs 128 bit but, accidently, IPFS Go's
            // implementation only uses the first 64, so we must do the same
            // for parity..
            justHash = hash.slice(2, 10);
            length = justHash.length;
            result = Buffer.alloc(length); // TODO: invert buffer because that's how Go impl does it

            for (i = 0; i < length; i++) {
              result[length - i - 1] = justHash[i];
            }

            return _context.abrupt("return", result);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hashFn(_x6) {
    return _ref.apply(this, arguments);
  };
}();

hashFn.code = 0x22; // TODO: get this from multihashing-async?

var defaultOptions = {
  hamtHashFn: hashFn,
  hamtBucketBits: 8
};

var DirSharded = /*#__PURE__*/function (_Dir) {
  _inherits(DirSharded, _Dir);

  var _super = _createSuper(DirSharded);

  function DirSharded(props, options) {
    var _this3;

    _classCallCheck(this, DirSharded);

    options = mergeOptions(defaultOptions, options);
    _this3 = _super.call(this, props, options);
    _this3._bucket = Bucket({
      hashFn: options.hamtHashFn,
      bits: options.hamtBucketBits
    });
    return _this3;
  }

  _createClass(DirSharded, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._bucket.put(name, value);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function put(_x7, _x8) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function get(name) {
      return this._bucket.get(name);
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return this._bucket.leafCount();
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this._bucket.childrenCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._bucket.onlyChild();
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value5, key, value;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context3.prev = 2;
                _iterator = _asyncIterator(_this._bucket.eachLeafSeries());

              case 4:
                _context3.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 18;
                  break;
                }

                _value5 = _value, key = _value5.key, value = _value5.value;
                _context3.next = 15;
                return {
                  key: key,
                  child: value
                };

              case 15:
                _iteratorNormalCompletion = true;
                _context3.next = 4;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 29;
                return _awaitAsyncGenerator(_iterator.return());

              case 29:
                _context3.prev = 29;

                if (!_didIteratorError) {
                  _context3.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context3.finish(29);

              case 33:
                return _context3.finish(24);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 20, 24, 34], [25,, 29, 33]]);
      }))();
    }
  }, {
    key: "flush",
    value: function flush(path, block) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, entry;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context4.prev = 2;
                _iterator2 = _asyncIterator(_flush2(path, _this2._bucket, block, _this2, _this2.options));

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                _step2 = _context4.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context4.next = 10;
                return _awaitAsyncGenerator(_step2.value);

              case 10:
                _value2 = _context4.sent;

                if (_iteratorNormalCompletion2) {
                  _context4.next = 18;
                  break;
                }

                entry = _value2;
                _context4.next = 15;
                return entry;

              case 15:
                _iteratorNormalCompletion2 = true;
                _context4.next = 4;
                break;

              case 18:
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 24:
                _context4.prev = 24;
                _context4.prev = 25;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context4.next = 29;
                  break;
                }

                _context4.next = 29;
                return _awaitAsyncGenerator(_iterator2.return());

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError2) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(24);

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 20, 24, 34], [25,, 29, 33]]);
      }))();
    }
  }]);

  return DirSharded;
}(Dir);

module.exports = DirSharded;
module.exports.hashFn = hashFn;

function _flush2(_x, _x2, _x3, _x4, _x5) {
  return _flush.apply(this, arguments);
}

function _flush() {
  _flush = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, bucket, block, shardRoot, options) {
    var children, links, childrenSize, i, child, labelPrefix, shard, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, subShard, _dir, flushedDir, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _value4, entry, label, value, _label, _size, data, dir, node, buffer, cid, size;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            children = bucket._children;
            links = [];
            childrenSize = 0;
            i = 0;

          case 4:
            if (!(i < children.length)) {
              _context5.next = 105;
              break;
            }

            child = children.get(i);

            if (child) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("continue", 102);

          case 8:
            labelPrefix = i.toString(16).toUpperCase().padStart(2, '0');

            if (!Bucket.isBucket(child)) {
              _context5.next = 52;
              break;
            }

            shard = void 0;
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _context5.prev = 13;
            _context5.t0 = _asyncIterator;
            _context5.next = 17;
            return _awaitAsyncGenerator(_flush2('', child, block, null, options));

          case 17:
            _context5.t1 = _context5.sent;
            _iterator3 = (0, _context5.t0)(_context5.t1);

          case 19:
            _context5.next = 21;
            return _awaitAsyncGenerator(_iterator3.next());

          case 21:
            _step3 = _context5.sent;
            _iteratorNormalCompletion3 = _step3.done;
            _context5.next = 25;
            return _awaitAsyncGenerator(_step3.value);

          case 25:
            _value3 = _context5.sent;

            if (_iteratorNormalCompletion3) {
              _context5.next = 32;
              break;
            }

            subShard = _value3;
            shard = subShard;

          case 29:
            _iteratorNormalCompletion3 = true;
            _context5.next = 19;
            break;

          case 32:
            _context5.next = 38;
            break;

          case 34:
            _context5.prev = 34;
            _context5.t2 = _context5["catch"](13);
            _didIteratorError3 = true;
            _iteratorError3 = _context5.t2;

          case 38:
            _context5.prev = 38;
            _context5.prev = 39;

            if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
              _context5.next = 43;
              break;
            }

            _context5.next = 43;
            return _awaitAsyncGenerator(_iterator3.return());

          case 43:
            _context5.prev = 43;

            if (!_didIteratorError3) {
              _context5.next = 46;
              break;
            }

            throw _iteratorError3;

          case 46:
            return _context5.finish(43);

          case 47:
            return _context5.finish(38);

          case 48:
            links.push(new DAGLink(labelPrefix, shard.size, shard.cid));
            childrenSize += shard.size;
            _context5.next = 102;
            break;

          case 52:
            if (!(typeof child.value.flush === 'function')) {
              _context5.next = 95;
              break;
            }

            _dir = child.value;
            flushedDir = void 0;
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _context5.prev = 57;
            _iterator4 = _asyncIterator(_dir.flush(_dir.path, block));

          case 59:
            _context5.next = 61;
            return _awaitAsyncGenerator(_iterator4.next());

          case 61:
            _step4 = _context5.sent;
            _iteratorNormalCompletion4 = _step4.done;
            _context5.next = 65;
            return _awaitAsyncGenerator(_step4.value);

          case 65:
            _value4 = _context5.sent;

            if (_iteratorNormalCompletion4) {
              _context5.next = 74;
              break;
            }

            entry = _value4;
            flushedDir = entry;
            _context5.next = 71;
            return flushedDir;

          case 71:
            _iteratorNormalCompletion4 = true;
            _context5.next = 59;
            break;

          case 74:
            _context5.next = 80;
            break;

          case 76:
            _context5.prev = 76;
            _context5.t3 = _context5["catch"](57);
            _didIteratorError4 = true;
            _iteratorError4 = _context5.t3;

          case 80:
            _context5.prev = 80;
            _context5.prev = 81;

            if (!(!_iteratorNormalCompletion4 && _iterator4.return != null)) {
              _context5.next = 85;
              break;
            }

            _context5.next = 85;
            return _awaitAsyncGenerator(_iterator4.return());

          case 85:
            _context5.prev = 85;

            if (!_didIteratorError4) {
              _context5.next = 88;
              break;
            }

            throw _iteratorError4;

          case 88:
            return _context5.finish(85);

          case 89:
            return _context5.finish(80);

          case 90:
            label = labelPrefix + child.key;
            links.push(new DAGLink(label, flushedDir.size, flushedDir.cid));
            childrenSize += flushedDir.size;
            _context5.next = 102;
            break;

          case 95:
            value = child.value;

            if (value.cid) {
              _context5.next = 98;
              break;
            }

            return _context5.abrupt("continue", 102);

          case 98:
            _label = labelPrefix + child.key;
            _size = value.size;
            links.push(new DAGLink(_label, _size, value.cid));
            childrenSize += _size;

          case 102:
            i++;
            _context5.next = 4;
            break;

          case 105:
            // go-ipfs uses little endian, that's why we have to
            // reverse the bit field before storing it
            data = Buffer.from(children.bitField().reverse());
            dir = new UnixFS({
              type: 'hamt-sharded-directory',
              data: data,
              fanout: bucket.tableSize(),
              hashType: options.hamtHashFn.code,
              mtime: shardRoot && shardRoot.mtime,
              mode: shardRoot && shardRoot.mode
            });
            node = new DAGNode(dir.marshal(), links);
            buffer = node.serialize();
            _context5.next = 111;
            return _awaitAsyncGenerator(persist(buffer, block, options));

          case 111:
            cid = _context5.sent;
            size = buffer.length + childrenSize;
            _context5.next = 115;
            return {
              cid: cid,
              unixfs: dir,
              path: path,
              size: size
            };

          case 115:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[13, 34, 38, 48], [39,, 43, 47], [57, 76, 80, 90], [81,, 85, 89]]);
  }));
  return _flush.apply(this, arguments);
}